import { render, staticRenderFns } from "./reviewApplyRoomDiscount.vue?vue&type=template&id=66f9c688&scoped=true"
import script from "./reviewApplyRoomDiscount.vue?vue&type=script&lang=js"
export * from "./reviewApplyRoomDiscount.vue?vue&type=script&lang=js"
import style0 from "./reviewApplyRoomDiscount.vue?vue&type=style&index=0&id=66f9c688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f9c688",
  null
  
)

export default component.exports